// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ContentNew_contentWrapper__19C6F"};